/**
 * @description
 * Objeto Rol EXternal
 */

export class RolsExternal {
    public id:number = null;
    public code:string = "";
    public descripcion:string = "";
    public enable:number=null;

  
    constructor() {}
  
}